import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import ALoader from 'views/pages/manage/common/a-loader';
import { bulkActiveActionsDropdown, bulkInactiveActionsDropdown, getStatusDropdown, newRow, statusDropdown } from './constant';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { GridRowModes } from '@mui/x-data-grid';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { ActionsCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { Box, Tooltip } from '@mui/material';
import { editCellContainerStyle } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { FaCheck } from 'react-icons/fa6';
import Footer from 'modules/studentTransfer/components/Footer';
import CommonInput from 'views/pages/manage/common/formFeilds/input/commonInput';
import { StatusCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import CustomChip from 'views/pages/manage/common/customChip/CustomChip';
import { getStatusStyles } from 'modules/studentTransfer/transferSetup/transferValidationConfig/constant';
import { getFormatedLastUpdatedOn } from 'modules/userManagement/mappings/constant';
import CustomTooltip from 'views/pages/manage/common/customTooltip/CustomTooltip';
import CourseCompletionTitle from './CourseCompletionTooltip';

export const RoundUnCheckedIcon = () => {
    return (
        <Box
            sx={{
                width: 18,
                height: 18,
                borderRadius: "50%",
                border: "1.5px solid #E2E2E2",
            }}
        />
    )
}

export const RoundCheckedIcon = () => {
    return (
        <Box
            sx={{
                width: 18,
                height: 18,
                borderRadius: "50%",
                backgroundColor: '#00B0F5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <FaCheck color="white" size={12} />
        </Box>
    )
}

export const dataGridRoundCheckBoxes =
{
    baseCheckbox: {
        icon: <RoundUnCheckedIcon />,
        checkedIcon: <RoundCheckedIcon />
    }
}


const ListComponent = forwardRef(({
    rows,
    selectedTab,
    loader,
    dropdowns,
    createUpdateHandler,
    deleteHandler,
    currentPage,
    getCompletionRefundList,
    rowCount,
    currPageSize,
    status,
    bulkAction,
    setBulkAction,
    bulkApplyHandler,
    userPermissions
}, ref) => {

    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [selectionModel, setSelectionModel] = useState([])
    const [rowForm, setRowForm] = useState({})

    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({ ...prev, [key]: value }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);

    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };
    const handleDeleteClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            deleteHandler(params?.row)
        }
    }

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = async (params) => {
        createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let emptyRow = {
                ...newRow,
                isNew: true,
                id: generateRandomId(),
            };
            // let randomId = JSON.stringify(emptyRow);
            startEditing(emptyRow?.id, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));


    const toggleStatusHandler = () => {

    }



    const onChangeHandler = (page, pageSize) => {
        getCompletionRefundList(page, pageSize)
    }

    const isRowSelectable = (params) => {
        // not let user select rows with status 'Delivered'
        if (isObjEmpty(rowForm)) {
            return true;
        }
    };


    const columns = [
        new AGridColDef("businessAreaValue", "BU", true)
            .setMinWidth(110)
            .editable(false)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`} >{params?.value}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("sdCourseId", "SD Course ID", true)
            .setMinWidth(140)
            .editable(false)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`} >{params?.value}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("regularCourseId", "Reg Course ID", true)
            .setMinWidth(150)
            .editable(false)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`} >{params?.value}</div>
                </Tooltip> : <div>-</div>
            ))
        ,
        new AGridColDef("termValue", "Reg Term", true)
            .setMinWidth(110)
            .editable(false)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`} >{params?.value}</div>
                </Tooltip> : <div>-</div>
            ))
        ,
        new AGridColDef("regularCourseIdDescription", "Regular Course ID Desc", false)
            .setMinWidth(140)
            .editable(false)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`} >{params?.value}</div>
                </Tooltip> : <div>-</div>
            ))
        ,

        new AGridColDef("updatedOn", "Last Updated On", false)
            .setMinWidth(140)
            .editable(false)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={getFormatedLastUpdatedOn(params)}>
                    <div className={`ellipsis-text-container`} >{getFormatedLastUpdatedOn(params)}</div>
                </Tooltip> : <div>-</div>
            ))
        ,

        new AGridColDef("status", "Status", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
                <CustomChip
                    text={params?.value}
                    textColor={getStatusStyles((params?.value).toUpperCase())?.textColor}
                    bgColor={getStatusStyles((params?.value).toUpperCase())?.bgColor}
                />
            ))
            .renderEditCellComponent((params) => <div style={editCellContainerStyle}>
                <AAutoComplete
                    currentValue={rowForm?.status?.label ? rowForm?.status : { label: rowForm?.status, value: rowForm?.status }}
                    handleChange={value => {
                        rowFormHandler(value, 'status');
                    }}
                    items={[getStatusDropdown(rowForm?.status?.label ?? rowForm?.status)]}
                    isMulti={false}
                    placeholder={'Select'}
                    autoFocus={params?.hasFocus}
                />
            </div>
            ),
        ...(userPermissions?.includes("U") ? [new AGridColDef("action", "Action", false)
            .setMinWidth(460)
            .editable(false)
            .setFlex(4)
            .renderCellComponent((params) => (
                <div className='d-flex align-items-center' style={{ gap: '15px' }}>
                    {params.api.getRowMode(params?.id) == 'view' && <>{(
                        params?.row?.cronEnabled) ? <CustomTooltip
                            maxWidth='300px'
                            title={<CourseCompletionTitle
                            courseCompletionData={{
                                updatedOn: params?.row?.cronExecutionTime,
                                updatedBy: params?.row?.updatedBy
                            }}
                            />}
                            showOnClick={false}

                        ><span>
                            <AButton
                                variant="outline"
                                className="button_remove_left_margin"
                                disabled={
                                    (params?.row?.status).toUpperCase() !== "ACTIVE" ||
                                    params?.row?.cronEnabled
                                }
                                onClick={() => createUpdateHandler(params?.row, "autoInitiate")}
                                size="xs"
                            >
                                Auto-initiate refunds
                            </AButton>
                        </span>
                    </CustomTooltip> :
                        <AButton
                            variant="outline"
                            className="button_remove_left_margin"
                            disabled={
                                (params?.row?.status).toUpperCase() !== "ACTIVE" ||
                                params?.row?.cronEnabled
                            }
                            onClick={() => createUpdateHandler(params?.row, "autoInitiate")}
                            size="xs"
                        >
                            Auto-initiate refunds
                        </AButton>
                    }

                        <AButton
                            variant="outline"
                            size="xs"
                            className="button_remove_left_margin"
                            disabled={(params?.row?.status).toUpperCase() != "ACTIVE" || params?.row?.blockRfidEnabled}
                            // updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                            onClick={() => { createUpdateHandler(params?.row, 'blockRFID') }}
                        >
                            Block RFID
                        </AButton></>}
                    <ActionsCellComponent
                        mode={params.api.getRowMode(params?.id)}
                        handleEditClick={handleEditClick}
                        handleSaveClick={handleSaveClick}
                        handleCancelClick={handleCancelClick}
                        //handleDeleteClick={handleDeleteClick}
                        icon={true}
                        cancelIcon={<CancelIcon
                            className="mx-2 cursor"
                            onClick={() => handleCancelClick(params)}
                        />}
                        //deleteIcon={true}
                        params={params}
                        // editPermission={userPermissions?.includes("U")}
                        // deletePermission={userPermissions?.includes("D")}
                        customEditIcon
                    />
                </div>
            ))] : [])
    ]

    return (<>
        {loader && <ALoader position="fixed" />}

        <ADataGrid
            removeWrapperContainer
            rowModesModel={rowModesModel}
            height={status != 'ALL' && 300}
            rows={rowData || []}
            columns={columns}
            rowId={(row) => row?.id}
            rowHeight={50}
            loading={false}
            rowCount={rowCount}
            currentPage={currentPage}
            nextButtonHandler={onChangeHandler}

            sx={{
                ...gridStyles,
            }}
            autoHeight
            // pinLastColumn={selectedTab?.key!='logs'&&(userPermissions?.includes("C") ||userPermissions?.includes("U"))?true:false}
            paginationModel={{ page: currentPage, pageSize: currPageSize }}
            isRowSelectable={isRowSelectable}
            hideFooterSelectedRowCount={true}
            checkboxSelection={status != 'ALL' && rows.length > 0 && userPermissions?.includes("B")}
            disableSelectionOnClick
            selectionModel={selectionModel}
            onSelectionModelChange={(newSelectionModel) => {
                if (newSelectionModel.length == 0) {
                    setBulkAction('')
                }
                setSelectionModel(newSelectionModel);
            }}
            checkbox={dataGridRoundCheckBoxes}
        />

        {status != "ALL" && rows.length > 0 && userPermissions?.includes("B") && <Footer>
            <div className='large-text d-flex align-items-center'>{selectionModel?.length ? `${selectionModel.length} items selected` : 'Bulk actions'}</div>
            <div className='d-flex align-items-center justify-content-between' style={{ width: '30%' }}>
                <CommonInput
                    defaultValue={bulkAction}
                    required={true}
                    type={"select"}
                    menuPlacement={"top"}
                    data={status == 'ACTIVE' ? bulkActiveActionsDropdown : bulkInactiveActionsDropdown}
                    singleValue={true}
                    onChange={(e) => {
                        setBulkAction(e)
                    }}
                    updatedStyle={{ marginBottom: 0, width: '44%' }}
                    isDisabled={selectionModel.length == 0}
                //error={}
                />
                <AButton
                    disabled={(!!bulkAction) != true}
                    onClick={() => { bulkApplyHandler(selectionModel, bulkAction) }}
                    className="button_remove_left_margin"
                    variant="primary_filled"
                >
                    Apply
                </AButton>
            </div>
        </Footer>
        }

    </>
    );
})

export default ListComponent;